import { z } from 'zod';
import { defineEndpoint } from '../define';
import { UserListItemSchema } from './list';

export const CreateUserBodySchema = z.object({
  email: z
    .string()
    .trim()
    .min(1)
    .max(254)
    .transform((s) => s.toLowerCase())
    .pipe(z.string().email()),
  roleIds: z
    .array(z.string().uuid())
    .min(1)
    .transform((ids) => [...new Set(ids)]),
});

export type CreateUserBody = z.infer<typeof CreateUserBodySchema>;

export const CreateUserResponseSchema = z.object({
  data: UserListItemSchema,
});

export const createUser = defineEndpoint({
  method: 'POST',
  path: '/v1/users',
  params: z.object({}),
  query: z.object({}),
  body: CreateUserBodySchema,
  response: CreateUserResponseSchema,
  successStatus: 201,
});
